import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { persistStore, persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage/session'
import rootReducer from 'reducers';
import rootSaga from 'sagas/rootSaga';
import thunk from 'redux-thunk';
import AGENT_BASIC_INFO from 'agent-basic-info';
import AGENTLOGIN from 'agentlogin';
import MENU_ACTIONS from 'menu-actions';
import CUSTOMER_SEARCH_WIDGET from 'customer-search-widget';
import CUSTOMER_INFORMATION_BANNER from 'customer-information-banner';
import PRODUCTS_AND_SERVICES from 'products-and-services';
import NAVIGATION_HEADER from 'navigation-header';
import ERROR_MODAL from 'error-modal';
import GENERIC_ACTIONS from 'generic-actions';
import TOPUP from 'topup';
import PLAN_TYPE_MODAL from 'plan-type-modal';
import BUNDLE_DETAILS from 'bundle-details';
import SERVICE_DETAILS_HEADER from 'service-details-header';
import SERVICE_TAGS from 'service-tags';
import PLANS_CARD from 'plans-card';
import CONSUMPTION_CARD from 'consumption-card';
import PEGA_OFFERS from 'pega-offers';
import BARRING_MANAGEMENT from 'barring-management';
import CUSTOMER_DASHBOARD_ADDONS from 'customer-dashboard-addons';
import PEGA_DETAILS from 'pega-details';
import DROOLS from 'drools';
import page64c79cb159c19d71967011feJson from 'pages/page_64c79cb159c19d71967011fe.json';
import page64c79cb159c19d7196701200Json from 'pages/page_64c79cb159c19d7196701200.json';
import page64c79cb159c19d719670120cJson from 'pages/page_64c79cb159c19d719670120c.json';
import page64c79cb159c19d719670121cJson from 'pages/page_64c79cb159c19d719670121c.json';
import page64c79cb159c19d7196701221Json from 'pages/page_64c79cb159c19d7196701221.json';
import page64c79cb159c19d719670122bJson from 'pages/page_64c79cb159c19d719670122b.json';
import page64c79cb159c19d7196701231Json from 'pages/page_64c79cb159c19d7196701231.json';
import page64c79cb259c19d7196701279Json from 'pages/page_64c79cb259c19d7196701279.json';
import routesJson from 'pages/routes.json';
import genericPagesJson from '../pages/genericPages.json';
import sharedPagesJson from '../pages/sharedPages.json';

import ValidationService from '../services/ValidationService.js';
import { history } from '../sharedHistory';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const initialState = {
  pages: {
    page_64c79cb159c19d71967011fe: page64c79cb159c19d71967011feJson,
    page_64c79cb159c19d7196701200: page64c79cb159c19d7196701200Json,
    page_64c79cb159c19d719670120c: page64c79cb159c19d719670120cJson,
    page_64c79cb159c19d719670121c: page64c79cb159c19d719670121cJson,
    page_64c79cb159c19d7196701221: page64c79cb159c19d7196701221Json,
    page_64c79cb159c19d719670122b: page64c79cb159c19d719670122bJson,
    page_64c79cb159c19d7196701231: page64c79cb159c19d7196701231Json,
    page_64c79cb259c19d7196701279: page64c79cb259c19d7196701279Json,
    routes: routesJson,
    genericPages: genericPagesJson,
    sharedPages:sharedPagesJson,
    menuItems: [
    {
      route: '/dashboard',
      name: 'agentdashboard'
    },
    {
      route: '/page/customersearch',
      name: 'customersearch'
    },
    {
      route: '/page/customerdashboard',
      name: 'customerdashboard'
    },
    {
      route: '/page/sellablebundledetails',
      name: 'sellablebundledetails'
    },
    {
      route: '/page/activebundledetails',
      name: 'activebundledetails'
    },
    {
      route: '/page/prepaiddashboard',
      name: 'prepaiddashboard'
    },
    {
      route: '/page/campaigndetails',
      name: 'campaigndetails'
    },
    ]
  }
};

const authItem = localStorage.getItem('auth');
if (authItem) {
  initialState.authentication = JSON.parse(authItem);
}

const sagaMiddleware = createSagaMiddleware();

const wrapper = (pckg, mid) => store => next => action => {
  if(action.type.startsWith(`@${pckg}/`)) {
    return mid(store)(next)(action);
  } else {
    return next(action);
  }
};


const validator = store => next => action => {
  if(ValidationService.validateable(action)) {
    ValidationService.validate(action)
    .then(res => {
      if(res) {
        console.log('Successfull validation:', action);
      } else {
        console.log('Invalid payload contents', action);
      }
    });
  }
  return next(action);
}


const middlewares = [
  ...(AGENT_BASIC_INFO.middlewares ? AGENT_BASIC_INFO.middlewares.map(mid => wrapper('agent-basic-info',mid)) : []),
  ...(AGENTLOGIN.middlewares ? AGENTLOGIN.middlewares.map(mid => wrapper('agentlogin',mid)) : []),
  ...(MENU_ACTIONS.middlewares ? MENU_ACTIONS.middlewares.map(mid => wrapper('menu-actions',mid)) : []),
  ...(CUSTOMER_SEARCH_WIDGET.middlewares ? CUSTOMER_SEARCH_WIDGET.middlewares.map(mid => wrapper('customer-search-widget',mid)) : []),
  ...(CUSTOMER_INFORMATION_BANNER.middlewares ? CUSTOMER_INFORMATION_BANNER.middlewares.map(mid => wrapper('customer-information-banner',mid)) : []),
  ...(PRODUCTS_AND_SERVICES.middlewares ? PRODUCTS_AND_SERVICES.middlewares.map(mid => wrapper('products-and-services',mid)) : []),
  ...(NAVIGATION_HEADER.middlewares ? NAVIGATION_HEADER.middlewares.map(mid => wrapper('navigation-header',mid)) : []),
  ...(ERROR_MODAL.middlewares ? ERROR_MODAL.middlewares.map(mid => wrapper('error-modal',mid)) : []),
  ...(GENERIC_ACTIONS.middlewares ? GENERIC_ACTIONS.middlewares.map(mid => wrapper('generic-actions',mid)) : []),
  ...(TOPUP.middlewares ? TOPUP.middlewares.map(mid => wrapper('topup',mid)) : []),
  ...(PLAN_TYPE_MODAL.middlewares ? PLAN_TYPE_MODAL.middlewares.map(mid => wrapper('plan-type-modal',mid)) : []),
  ...(BUNDLE_DETAILS.middlewares ? BUNDLE_DETAILS.middlewares.map(mid => wrapper('bundle-details',mid)) : []),
  ...(SERVICE_DETAILS_HEADER.middlewares ? SERVICE_DETAILS_HEADER.middlewares.map(mid => wrapper('service-details-header',mid)) : []),
  ...(SERVICE_TAGS.middlewares ? SERVICE_TAGS.middlewares.map(mid => wrapper('service-tags',mid)) : []),
  ...(PLANS_CARD.middlewares ? PLANS_CARD.middlewares.map(mid => wrapper('plans-card',mid)) : []),
  ...(CONSUMPTION_CARD.middlewares ? CONSUMPTION_CARD.middlewares.map(mid => wrapper('consumption-card',mid)) : []),
  ...(PEGA_OFFERS.middlewares ? PEGA_OFFERS.middlewares.map(mid => wrapper('pega-offers',mid)) : []),
  ...(BARRING_MANAGEMENT.middlewares ? BARRING_MANAGEMENT.middlewares.map(mid => wrapper('barring-management',mid)) : []),
  ...(CUSTOMER_DASHBOARD_ADDONS.middlewares ? CUSTOMER_DASHBOARD_ADDONS.middlewares.map(mid => wrapper('customer-dashboard-addons',mid)) : []),
  ...(PEGA_DETAILS.middlewares ? PEGA_DETAILS.middlewares.map(mid => wrapper('pega-details',mid)) : []),
  ...(DROOLS.middlewares ? DROOLS.middlewares.map(mid => wrapper('drools',mid)) : []),
];

const persistConfig = {
  key: "root",
  storage: storage,
  version: 0,
  whitelist: ["props"] // This is for core app reducers, widgets have their own 'persistedReducer'
};

const persistedReducer = persistReducer(
  persistConfig,
  rootReducer
);

const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(routerMiddleware(history), validator, sagaMiddleware, thunk, ...middlewares))
);

const persistor = persistStore(store);


sagaMiddleware.run(rootSaga);

export { store, persistor };

